import React from "react";
import Label from "components/general/Label"
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";


export function Footer({ data }) {
    const formatDate = Label({ data: 'BracketDateFormat' });
    const formatDateTime = Label({ data: 'BracketDateTimeFormat' });
    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, TDB</>
    const time = data?.bi_time && <DateTime datetime={dateTime} format={"HH:mm"} />
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status'>{data?.result?.status?.code}</div>}
            <div className="d-flex">
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-start w-40'>{dateComponent}</div>}
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-end w-80'><Label data='LabelContest' /> {numberGame}</div>}
            </div>
        </>
    )
}

export function CompetitorBlock(competitor) {
    return (
        <div className='score-competitor-container  d-flex flex-row justify-content-start'>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className='score-noc'>
                <Noc className='me-1' {...competitor?.participant?.organisation} />
            </div>
            <div className='score-name'><Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} /></div>
            <div><sup>{'(' + competitor.co_seed + ')'}</sup></div>
        </div>
    )
}

